import { render, staticRenderFns } from "./lecturerDetail.vue?vue&type=template&id=468a9c90&scoped=true&"
import script from "./lecturerDetail.vue?vue&type=script&lang=js&"
export * from "./lecturerDetail.vue?vue&type=script&lang=js&"
import style0 from "./lecturerDetail.vue?vue&type=style&index=0&id=468a9c90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a9c90",
  null
  
)

export default component.exports